
            const data = {"name":"close","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"m12 4-8 8M4 4l8 8\" _stroke=\"#fff\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    